<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right">
        <div class="title-default">帮助中心</div>
        <el-collapse v-model="activeNames" accordion class="help-info">
          <el-collapse-item class="help-title" :title="item.title" :name="item.title" v-for="(item, index) in helpData.pageList" :key="index">
            <div v-html="item.content">
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
export default {
  components: {
    userTab
  },
  data() {
    return {
      activeNames: "",
      helpData:{
        pageList:[]
      }
    };
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "首页") {
        i.isSelected = true;
      }
    }
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "帮助中心") {
        i.isSelected = true;
      }
    }
    if (Cookies.get("token") != undefined) {
    this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=50&typeCode=help`
      ).then(res => {
        if (res.code == 0) {
          _this.helpData = res.data;
          if(JSON.stringify(_this.$route.query)=='{}'){
          _this.activeNames=res.data.pageList[0].title
          }else{
            _this.activeNames=_this.$route.query.index
          }
        } else {
          this.$message(res.message);
        }
      });
    }
  },

  methods: {
  }
};
</script>
<style lang="scss">
.help-info {
  margin-top: 15px;
  .help-title {
    margin-top: 10px;
    .el-collapse-item__wrap {
      border-bottom: none;
    }
    .el-collapse-item__header,
    .el-collapse-item__content {
      padding: 0 20px;
    }
    .el-collapse-item__header {
      height: 46px;
      background: rgba(249, 250, 250, 1);
      color: #2f3133;
      font-size: 16px;
      font-weight: bold;
      border-bottom: none;
      .el-collapse-item__arrow {
        color: #d8d8d8;
        font-size: 20px;
      }
    }
  }
  .help-title:nth-child(1) {
    margin-top: 0;
  }
}
</style>
<style lang="scss" scoped>
.title-default {
  background: #ffffff;
  color: #5e6066;
}
</style>